/**
 * Startup Insights Module
 *
 * Exports for the Startup Insights system.
 */

export {
  useStartupInsights,
  profileToInsightsContext,
  addScoresToInsightsContext,
  scoreCriteriaToContextDimensions,
  insightsActionItemToRecommendation,
  type UseStartupInsightsOptions,
  type UseStartupInsightsReturn,
} from './use-startup-insights';

export {
  INSIGHTS_QUICK_ACTIONS,
  ACTION_ITEM_CATEGORIES,
  type InsightsQuickAction,
  type ActionItemCategory,
  type InsightsUIState,
  type InsightsMessageProps,
  type InsightsInputProps,
  type InsightsContainerProps,
} from './types';

// Re-export types from edge-functions
export type {
  InsightsMessage,
  InsightsRole,
  InsightsStartupContext,
  InsightsFocusArea,
  InsightsActionItem,
  InsightsRequest,
  InsightsResponse,
} from '@/lib/supabase/edge-functions';
